import {
  Dialog,
  DialogContent,
  DialogTitle,
  List,
  ListItem,
  ListItemText,
  CircularProgress,
  Button,
  DialogActions,
} from "@mui/material";
import { useState, useEffect } from "react";
import { getJwtTokenFromIdToken } from "../auth/AuthFanc";

interface BaseSelectionModalProps {
  baseModalOpen: boolean;
  setBaseModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setFulltechOfficeName: React.Dispatch<React.SetStateAction<any>>;
  setFulltechOfficeId: React.Dispatch<React.SetStateAction<any>>;
}

export const BaseSelectionModal: React.FC<BaseSelectionModalProps> = ({
  baseModalOpen,
  setBaseModalOpen,
  setFulltechOfficeName,
  setFulltechOfficeId,
}) => {
  const [bases, setBases] = useState<
    Array<{
      autoFulltechOfficeId: number;
      fulltechOfficeId: number;
      officeName: string;
      officeAddress: string;
    }>
  >([]);
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    const fetchOffices = async () => {
      setLoading(true); // ローディング開始
      try {
        const jwtToken = await getJwtTokenFromIdToken();

        // call indexFulltechOffices API
        const response = await fetch(
          process.env.REACT_APP_API_ENDPOINT + "/fulltech-offices",
          {
            headers: {
              Authorization: jwtToken,
            },
          }
        );

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const jsonResponse = await response.json();
        setBases(jsonResponse.fulltechOffices);
      } catch (error: any) {
        console.error("Error:", error);
      } finally {
        setLoading(false); // ローディング終了
      }
    };

    fetchOffices();
  }, []);

  return (
    <Dialog open={baseModalOpen} onClose={() => setBaseModalOpen(false)}>
      <DialogTitle>管轄拠点の選択</DialogTitle>
      <DialogContent>
        {loading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "20px",
            }}
          >
            <CircularProgress />
          </div>
        ) : (
          <List>
            {bases.map((base, index) => (
              <ListItem
                button
                key={index}
                onClick={() => {
                  setFulltechOfficeName(base.officeName);
                  setFulltechOfficeId(base.autoFulltechOfficeId);
                  setBaseModalOpen(false);
                }}
              >
                <ListItemText primary={base.officeName} />
              </ListItem>
            ))}
          </List>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setBaseModalOpen(false)}>閉じる</Button>
      </DialogActions>
    </Dialog>
  );
};
